import { Control } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { Grid } from '@mui/material';
import withReadModeField from 'components/shared/CRUD/components/InnerPage/components/withReadModeField';
import {
  ControlledDatePicker,
  ControlledTextField
} from 'components/shared/ControlledFields';

const NameFieldWithReadMode = withReadModeField(ControlledTextField);
const DescriptionFieldWithReadMode = withReadModeField(ControlledTextField);
const ValidFromFieldWithReadMode = withReadModeField(ControlledDatePicker);
const ValidToFieldWithReadMode = withReadModeField(ControlledDatePicker);

type Props = {
  control: Control<any>;
};

export default function EditProjectForm({ control }: Props) {
  const { t } = useTranslation();

  return (
    <Grid container mb={2.5} rowSpacing={2} columnSpacing={2}>
      <Grid xs={6} item={true}>
        <NameFieldWithReadMode
          name="name"
          control={control}
          label={t('name')}
          variant="outlined"
        />
      </Grid>
      <Grid xs={6} item>
        <DescriptionFieldWithReadMode
          name="description"
          control={control}
          label={t('description')}
          variant="outlined"
        />
      </Grid>
      <Grid xs={6} item={true}>
        <ValidFromFieldWithReadMode
          name="validFrom"
          control={control}
          label={t('validFrom')}
          variant="outlined"
          fullWidth
        />
      </Grid>
      <Grid xs={6} item>
        <ValidToFieldWithReadMode
          name="validTo"
          control={control}
          label={t('validTo')}
          variant="outlined"
          fullWidth
        />
      </Grid>
    </Grid>
  );
}
